export default "__VITE_ASSET__sBQzCOCJ__"